import { useStripe } from "@stripe/react-stripe-js";
import { useStateValue } from "./StateProvider";
const CheckoutButton = ({ sessionId }) => {
  const [{ basket, user }, dispatch] = useStateValue(); // pull from data layer
  const stripe = useStripe();
  const handleClick = async () => {
    try {
      //1. empty the basket
      dispatch({
        type: "EMPTY_BASKET",
      });
      //2. use the collected basket info to load stripe checkout session
      const { error } = await stripe.redirectToCheckout({ sessionId });
      if (error) {
        alert("Something went wrong !");
        // console.error("Error redirecting to checkout:", error);
      }
    } catch (error) {
      alert.show(" Something went wrong !");
      // console.error("Unexpected error:", error);
    }
  };
  return (
    <button onClick={handleClick} disabled={!stripe}>
      {<h3>Proceed to Check out</h3>}
    </button>
  );
};

export default CheckoutButton;
